import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type State = {
  moduleId: number | null;
};

type Action = {
  setModuleId: (moduleId: number | null) => void;
  clearModuleIdStore: () => void;
};

const initial: State = {
  moduleId: null,
};

export const useModuleIdStore = create<State & Action>()(
  persist(
    (set) => ({
      ...initial,
      setModuleId: (moduleId: number | null) =>
        set(() => ({ moduleId })),
      clearModuleIdStore: () => set({ ...initial }),
    }),
    {
      name: "module-id-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
